/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BlogEntryImage
 */
export interface BlogEntryImage {
    /**
     * 
     * @type {string}
     * @memberof BlogEntryImage
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogEntryImage
     */
    blogEntryId?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogEntryImage
     */
    imageId?: string;
}

/**
 * Check if a given object implements the BlogEntryImage interface.
 */
export function instanceOfBlogEntryImage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BlogEntryImageFromJSON(json: any): BlogEntryImage {
    return BlogEntryImageFromJSONTyped(json, false);
}

export function BlogEntryImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlogEntryImage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'blogEntryId': !exists(json, 'blogEntryId') ? undefined : json['blogEntryId'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
    };
}

export function BlogEntryImageToJSON(value?: BlogEntryImage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'blogEntryId': value.blogEntryId,
        'imageId': value.imageId,
    };
}

